import { gql } from 'graphql-tag';

export const GET_VIDEOS_QUERY = gql`
    query GetVideos(
        $timeline: [QueryArgument!],
        $organ: [QueryArgument!],
        $featuring: [QueryArgument!],
        $category: [CategoryRelationCriteriaInput!],
        $contributor: [EntryRelationCriteriaInput!],
        $search: String
    ) {
        videos: videosEntries(
            search: $search,
            timeline: $timeline,
            organ: $organ,
            featuring: $featuring,
            relatedToCategories: $category,
            relatedToEntries: $contributor,
            orderBy: "RAND()"
        ) {
            ... on videos_default_Entry {
                id
                title
                profile: videoProfile @transform(width: 112, format: "webp") {
                    id
                    url
                    title
                    srcset(sizes: ["1x", "2x", "3x"])
                }
                timeline
                description
                videoUrl
                firstNations
                interviewer(limit: 1) {
                    id
                    title
                    
                    ... on interviewer_Category {
                        description
                    }
                }
            }
        }
    }
`;
